export default {
    true: {
        head: [
            {name: "Отсутствует", drawable: -1, texture: 0},
            {name: "Черная панамка", drawable: 3, texture: 1},
            {name: "Бежевая панамка", drawable: 3, texture: 2},
            {name: "Черная шапка", drawable: 5, texture: 0},
            {name: "Серая шапка", drawable: 5, texture: 1},
            {name: "Зеленая кепка назад", drawable: 9, texture: 5},
            {name: "Зеленая кепка вперёд", drawable: 10, texture: 5},
            {name: "Фиолетовая кепка вперёд", drawable: 10, texture: 7},
            {name: "Новогодняя колпак 'Ёлка'", drawable: 97, texture: 0},
            {name: "Новогодняя колпак 'Волшебник'", drawable: 97, texture: 3},
            {name: "Новогодняя колпак 'Бубенцы'", drawable: 97, texture: 2},
        ],
        tops: [
            {name: "Белая футболка", drawable: 0, texture: 0},
            {name: "Серая футболка", drawable: 0, texture: 1},
            {name: "Черная футболка", drawable: 0, texture: 2},
            {name: "Желтая футболка", drawable: 0, texture: 3},
            {name: "Толстовка", drawable: 8, texture: 0},
            {name: "Новогодний свитер", drawable: 194, texture: 0},
            {name: "Белая рубашка", drawable: 144, texture: 0},
        ],
        legs: [
            {name: "Темные джинсы", drawable: 1, texture: 1},
            {name: "Серые джинсы", drawable: 1, texture: 2},
            {name: "Синие джинсы", drawable: 1, texture: 5},
            {name: "Темные зауженные джинсы", drawable: 4, texture: 0},
            {name: "Серые зауженные джинсы", drawable: 4, texture: 1},
            {name: "Светлые зауженные джинсы", drawable: 4, texture: 2},
            {name: "Бежевые шорты", drawable: 15, texture: 0},
            {name: "Коричневые шорты", drawable: 15, texture: 1},
            {name: "Белые шорты", drawable: 15, texture: 2},
            {name: "Темные шорты", drawable: 15, texture: 3},
        ],
        shoes: [
            {name: "Черные кеды", drawable: 1, texture: 0},
            {name: "Белые кеды", drawable: 1, texture: 1},
            {name: "Красные кеды", drawable: 1, texture: 10},
            {name: "Коричневые ботинки", drawable: 12, texture: 0},
            {name: "Голубые ботинки", drawable: 12, texture: 2},
            {name: "Черные ботинки", drawable: 12, texture: 6},
        ]
    },
    false: {
        head: [
            {name: "Отсутствует", drawable: -1, texture: 0},
            {name: "Черная шапка", drawable: 5, texture: 0},
            {name: "Белая шапка", drawable: 5, texture: 1},
            {name: "Розовая шапка", drawable: 5, texture: 2},
            {name: "Темная панамка", drawable: 3, texture: 7},
            {name: "Бежевая кепка", drawable: 10, texture: 7},
            {name: "Новогодняя шляпа", drawable: 97, texture: 0},
            {name: "Новогодняя шляпа 'Ёлка'", drawable: 39, texture: 0},
        ],
        tops: [
            {name: "Белая майка", drawable: 0, texture: 0},
            {name: "Розовая майка", drawable: 0, texture: 1},
            {name: "Черная майка", drawable: 0, texture: 2},
            {name: "Синяя майка", drawable: 0, texture: 6},
            {name: "Белое поло", drawable: 14, texture: 0},
            {name: "Розовое поло", drawable: 14, texture: 1},
            {name: "Нежно розовое поло", drawable: 14, texture: 2},
            {name: "Черное поло", drawable: 14, texture: 3},
            {name: "Новогодняя футболка", drawable: 19, texture: 0},
        ],
        legs: [
            {name: "Светлые джинсы", drawable: 0, texture: 0},
            {name: "Темные джинсы", drawable: 0, texture: 1},
            {name: "Короткие белые шорты", drawable: 10, texture: 0},
            {name: "Короткие синие шорты", drawable: 10, texture: 1},
            {name: "Белые спортивные штаны", drawable: 2, texture: 0},
            {name: "Серые спортивные штаны", drawable: 2, texture: 1},
            {name: "Черные спортивные штаны", drawable: 2, texture: 2},
        ],
        shoes: [
            {name: "Белые кеды", drawable: 1, texture: 0},
            {name: "Темные кеды", drawable: 1, texture: 1},
            {name: "Серые кеды", drawable: 1, texture: 2},
            {name: "Темные туфли", drawable: 13, texture: 0},
        ]
    }
}